import type { FC } from 'react';
import { Flex, Link } from '@chakra-ui/react';
import parse from 'html-react-parser';
import { FormattedMessage } from 'react-intl';
import { Header, Text } from '../../ui-components';
import type { ProductRelatedCategories } from '../../bff-api/products/model/ProductRelatedCategories';

export interface ProductsRelatedCategoriesProps {
    data: ProductRelatedCategories;
    className?: string;
}

export const ProductsRelatedCategories: FC<ProductsRelatedCategoriesProps> = ({
    data,
    className,
}) => {
    if (!data?.length) {
        return null;
    }

    return (
        <Flex
            data-testid="related-categories-container"
            direction="column"
            gap={4}
            className={className}
        >
            <Header id="related-categories-title" as="h4" variant="header4">
                <FormattedMessage id="related.categories" defaultMessage="Related Categories" />
            </Header>

            <Flex data-testid="related-categories-links" gap={2} wrap="wrap">
                {data.map((link) => {
                    const key = link.title.replace(/ /g, '_').toLowerCase();

                    return (
                        <Link
                            data-testid={`related-categories-links-${key}`}
                            key={key}
                            href={link.url}
                            backgroundColor="slt-grey-light"
                            paddingX={3}
                            paddingY={2}
                            borderRadius={4}
                        >
                            <Text style="bold" size="small">
                                {parse(link.title)}
                            </Text>
                        </Link>
                    );
                })}
            </Flex>
        </Flex>
    );
};

ProductsRelatedCategories.defaultProps = {
    className: undefined,
};
